import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataType, DataTypeAvailableOptions } from '@core/constants/data-types.constants';
import { InsuranceTarget } from '@core/models/insurance-target.model';
import { ConcreteInsuranceIds } from '@core/models/insurance.model';
import { LifePlan } from '@core/models/life-plan.model';
import { LanguageService } from '@i18n/services/language.service';
import { Store } from '@ngrx/store';
import { AppState } from '@redux/app.reducers';
import { RatingsState } from '@redux/reducers';
import { Subscription } from 'rxjs';
import { ModalOverlayRef } from '../../core/classes/modal-overlay.ref';

@Component({
  selector: 'mfp-financial-health',
  templateUrl: './financial-health.component.html',
  styleUrls: ['./financial-health.component.scss']
})
export class FinancialHealthComponent implements OnInit, OnDestroy {
  tabs: DataTypeAvailableOptions = [];
  activeTab = 0;
  option = 'default';
  hasSpouse = false;
  lifePlan!: LifePlan;
  ratings!: RatingsState;
  INSURANCE_DEATH_USER_ID = ConcreteInsuranceIds.DEATH_USER;
  INSURANCE_DEATH_SPOUSE_ID = ConcreteInsuranceIds.DEATH_SPOUSE;
  SAVING_GENERAL = ConcreteInsuranceIds.SAVING_GENERAL;
  INSURANCE_RETIREMENT_USER_ID = ConcreteInsuranceIds.RETIREMENT_USER;
  INSURANCE_RETIREMENT_SPOUSE_ID = ConcreteInsuranceIds.RETIREMENT_SPOUSE;

  $storeSubscription: Subscription;
  $languageSubscription!: Subscription;

  constructor(
    private languageService: LanguageService,
    public dialogRef: ModalOverlayRef,
    private store: Store<AppState>
  ) {
    this.$storeSubscription = this.store.subscribe({
      next: state => {
        this.lifePlan = state.lifePlan.currentLifePlan;
        if (this.lifePlan.spouse) {
          this.hasSpouse = true;
        }
        this.ratings = this.roundAll(state.ratings);
      }
    });
  }

  ngOnInit() {
    this.$languageSubscription = this.languageService.stream('FINANCIAL_HEALTH.TABS').subscribe({
      next: (tabs: any[]) => {
        this.tabs = tabs.map((tab, index) => {
          return { key: tab.TITLE as string, value: index };
        });
        this.activeTab = 0;
      }
    });
  }

  ngOnDestroy() {
    this.$storeSubscription.unsubscribe();
    this.$languageSubscription.unsubscribe();
  }

  onActiveTabChange(tab: DataType) {
    this.activeTab = tab as number;
  }

  close() {
    this.dialogRef.close();
  }

  roundAll(input: any): any {
    let output: any = {};
    for (const key in input) {
      if (Object.prototype.hasOwnProperty.call(input, key)) {
        if (typeof input[key] === 'object') {
          output[key] = this.roundAll(input[key]);
        } else if (typeof input[key] === 'number') {
          output[key] = Math.round(input[key]);
        }
      }
    }
    return output;
  }

  get savingInsuranceTargets(): InsuranceTarget[] {
    if (this.lifePlan.insurances) {
      return Object.values(this.lifePlan.insurances).filter(it => it.type === 'saving');
    }
    return [];
  }
}
